import { apiClient} from "api";
import {
  TNewFaxJob,
  TFaxSenderDetails
} from "./models/types";

const API_URL = "/FaxJob";

export const getSenderDetails = async (accountId : string): Promise<TFaxSenderDetails> => {
  const response = await apiClient.get<TFaxSenderDetails>(`${API_URL}/${accountId}/sender-details`);
  return response.data;
};

export const insertFax = async (faxJob : TNewFaxJob, accountId : string): Promise<number> => {
  const response = await apiClient.post<number>(`${API_URL}/${accountId}`, faxJob);
  return response.data;
}
